import apiClient from '@/services/api-client';

export default {
	async toolboxAddPointsAsync(campaignType, mediaType, exportType) {
		return await apiClient().post('/PartnerPoints/ToolboxAddPoints', {
			campaignType,
			mediaType,
			exportType,
		});
	},
	async toolboxCustomPostAddPointsAsync(exportType) {
		return await apiClient().post('/PartnerPoints/ToolboxAddPoints', {
			exportType,
		});
	},
	async contactsImportAddPointsAsync() {
		return await apiClient().post('/PartnerPoints/ContactsImportAddPoints');
	},
};
